import * as yup from "yup";

const acknowledgeValidationSchema = yup.object().shape({
  comment: yup.string().required(),
  status: yup.string().required(),
});

export default acknowledgeValidationSchema;
